export const INVOICE_SETTINGS_FIELD_UPDATE = 'INVOICE_SETTINGS_FIELD_UPDATE'
export const INVOICE_SETTINGS_FIELD_CLEAR = 'INVOICE_SETTINGS_FIELD_CLEAR'
